<div class="container">
    <div class="block-title">
        <div class="title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.CAPTION' | translate }}</div>
        <div class="subtitle">{{ (incidentGroupSelected == null ? 'SHARED.ROUTE.ACTIVE.INCIDENT.SELECTGROUP'
            : 'SHARED.ROUTE.ACTIVE.INCIDENT.SELECTINCIDENT') | translate }}</div>
    </div>

    <div class="buttons-group">
        <div class="action-card card-incident" *ngFor="let incidentGroup of getVisibleGroups()"
            [ngClass]="{'selected': isGroupSelected(incidentGroup)}" (click)="onIncidentGroupClick(incidentGroup)">
            <div class="icon-wrapper">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </div>
            <div class="card-body">
                <div class="card-title">{{ incidentGroup.incidentGroupCaption }}</div>
            </div>
            <i class="fa arrow-right" [ngClass]="isGroupSelected(incidentGroup) ? 'fa-times' : 'fa-chevron-right'" aria-hidden="true"></i>
        </div>

        <div class="action-card card-incident-detail" *ngFor="let incident of getVisibleIncidents()"
            [ngClass]="{'selected': isIncidentSelected(incident)}" (click)="onIncidentClick(incident)">
            <div class="card-body">
                <div class="card-title">{{ incident.incidentCaption }}</div>
            </div>
            <i class="fa arrow-right" [ngClass]="isIncidentSelected(incident) ? 'fa-check' : 'fa-chevron-right'" aria-hidden="true"></i>
        </div>
    </div>

    <ng-container *ngIf="getShowOtherData()">
        <div class="block-form">
            <textarea-component class="textarea" [(ngModel)]="comment" name="comment"
                placeholder="{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.COMMENT.PLACEHOLDER' | translate }}">
            </textarea-component>
        </div>

        <!-- Estic parat: només el conductor -->
        <div class="block-standstill" *ngIf="canStandStill()">
            <div class="action-card card-standstill" [ngClass]="{'selected': standStill}" (click)="onStandStill()">
                <div class="icon-wrapper">
                    <i class="fa fa-hand-paper-o" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL' | translate }}</div>
                    <div class="card-desc">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.HELP' | translate }}</div>
                </div>
                <i class="fa arrow-right" [ngClass]="standStill ? 'fa-check-square-o' : 'fa-square-o'" aria-hidden="true"></i>
            </div>
            <div class="block-time" *ngIf="getShowStandStillTime()">
                <div class="prompt">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.FORECAST' | translate }}</div>
                <time-caret [(ngModel)]="time" [min]="mintime"></time-caret>
            </div>
        </div>

        <div class="block-images">
            <shared-images [prefixFileNameImage]="getPrefixFileNameImage()" (takeImage)="onTakeImage($event)"
                [hideImage]="true" [miniImages]="'large'" [incident]="true"></shared-images>
        </div>
    </ng-container>

    <div class="block-buttons">
        <button class="btn-external danger" *ngIf="getShowOtherData()" (click)="onReport()"
            [disabled]="!isValid() || readonlyReport">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.REPORT' | translate }}</button>
    </div>
</div>
